// actions.js
import  apiClient  from '../../../../../services/apiClient';

export const kindergartenActions = {
  getPeriodYearsAndDistricts: async () => {
    return await apiClient.get('kindergartens/getKGGroupsYears');
  },

  getInfoAboutGroups: async (params) => {
    const queryString = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
    return await apiClient.get(`kindergartens/getInfoAboutGroupsAttends?${queryString}`);
  },

  updateReservedPlaces: async (kgId) => {
    return await apiClient.post('kindergartens/update_reserved_places', { kg_id: kgId });
  },

  setReserv: async (kgId) => {
    return await apiClient.post('kindergartens/update_reserved_places', { kg_id: kgId });
  }
};